module.exports = __webpack_public_path__ + "img/i-support.b9621fa0.svg";